const ternaryFunc = (condition: any, ifTrue: any, ifFalse: any) =>
  condition ? ifTrue : ifFalse;

export default ternaryFunc;
